<template>
    <div>
        <div class="banner">
            <div>
                <h3>氢气泄漏检测胶带</h3>
                <p>新型氢气泄漏检测方式</p>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title0">
                <div :class="{ 'introduct': true, 'fadeInUp': content0_title_animation }">
                    <div class="commit-tit">
                        <h3>产品介绍</h3>
                        <div class="small-text">Product introduction</div>
                    </div>
                </div>
                <p class="down" @click="download()">使用说明书</p>
            </div>
            <div class="common-content" id="content0">
                <p v-show="content0_content_animation">
                    氢气泄漏检测胶带是一种专门用于检测氢气泄漏的工具，具有使用方便，反应迅速，灵敏度高等优点。适用多种环境，可广泛应用干氢气生产、运输、储存和输送设施等领域，在氢气泄漏时迅速反应，改变颜色，以便及时发现泄漏并采取必要的措施，可以有效地保护设备和人员的安全，避免氢气泄漏造成的事故和损失，是保障氢能安全使用的重要工具之一。
                </p>
                <div v-show="content0_content_animation"
                    :class="{ 'img-parent': true, 'fadeInLeft': this.content0_content_animation }">
                    <img class="img" :src="t1" />
                </div>
                <el-divider direction="vertical"></el-divider>
                <div v-show="content0_content_animation"
                    :class="{ 'img-parent': true, 'fadeInRight': content0_content_animation }">
                    <img class="img" :src="t2" />
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title1">
                    <div :class="{ 'introduct': true, 'fadeInUp': content1_title_animation }">
                        <div class="commit-tit">
                            <h3>变色对比</h3>
                            <div class="small-text">Platform Parameters</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content1">
                    <div v-show="content1_content_animation" style="height:285px;" :class="{ 'img-parent': true, 'fadeInLeft': this.content1_content_animation }">
                        <img class="img" :src="t3" style="height:250px;margin-top:30px" />
                    </div>
                    <divider :class="{ 'fadeInLeft': this.content1_content_animation }"></divider>
                    <div v-show="content1_content_animation"
                        :class="{ 'img-parent': true, 'fadeInRight': content1_content_animation }">
                        <img class="img" :src="t4" />
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="common-title" id="title5">
                <div v-show="content5_title_animation" :class="{ 'introduct': true, 'fadeInUp': content5_title_animation }">
                    <div class="commit-tit">
                        <h3>产品特性</h3>
                        <div class="small-text">Product Characteristics</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content5">
                <div v-show="content5_content_animation" :class="{ 'fadeInUp': content5_content_animation }"
                    style="width: 100%;text-align: center;">
                    <table>
                        <tr>
                            <td>易定性：肉眼观察到胶带变色即为泄漏；</td>
                        </tr>
                        <tr>
                            <td>易定位：精准定位泄漏源;</td>
                        </tr>
                        <tr>
                            <td>易用性：无胶残留，适用于任何基材表面，使用方法与普通胶带一样;</td>
                        </tr>
                        <tr>
                            <td>环境耐受性：耐化学、耐紫外线、适用温度范围广;</td>
                        </tr>
                        <tr>
                            <td>变色反应迅速：感氢后颜色由黄色变为黑色(取决于氢的百分比);</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title2">
                    <div v-show="content2_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content2_title_animation }">
                        <div class="commit-tit">
                            <h3>产品规格</h3>
                            <div class="small-text">Product Specification</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content2">
                    <div v-show="content2_content_animation" :class="{ 'fadeInUp': content2_content_animation }"
                        style="width: 100%;">
                        <table>
                            <thead>
                                <tr>
                                    <th>规格</th>
                                    <th>测试方式</th>
                                    <th>数值</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>适用温度范围（连续）</td>
                                    <td></td>
                                    <td>-60F~450F(-54°C-232°C)</td>
                                </tr>
                                <tr>
                                    <td>适用温度范围（间隔）</td>
                                    <td></td>
                                    <td>-85F~500F(-65°C-260°C)</td>
                                </tr>
                                <tr>
                                    <td>最大温度易脆点</td>
                                    <td>ASTM D2137</td>
                                    <td>-85F(-65C)</td>
                                </tr>
                                <tr>
                                    <td>吸水率</td>
                                    <td>FED STD601方法6251</td>
                                    <td>按重量计算，最大3%</td>
                                </tr>
                                <tr>
                                    <td>抗拉强度</td>
                                    <td>ASTM D412</td>
                                    <td>最小700psi</td>
                                </tr>
                                <tr>
                                    <td>伸长率</td>
                                    <td>ASTM D412</td>
                                    <td>最小300%</td>
                                </tr>
                                <tr>
                                    <td>撕裂强度</td>
                                    <td></td>
                                    <td>85psi</td>
                                </tr>
                                <tr>
                                    <td>硬度</td>
                                    <td></td>
                                    <td>邵氏A50</td>
                                </tr>
                                <tr>
                                    <td>厚度公差</td>
                                    <td></td>
                                    <td>±0.002英寸（±0.05mm)</td>
                                </tr>
                                <tr>
                                    <td>宽度公差</td>
                                    <td></td>
                                    <td>+0.125英寸(+3.175mm)</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            反应时间受胶带温度或环境温度影响。温度越高，加快胶带变色反应速度，反之，温度越低，减缓反应速度
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="common-title" id="title3">
                <div v-show="content3_title_animation" :class="{ 'introduct': true, 'fadeInUp': content3_title_animation }">
                    <div class="commit-tit">
                        <h3>检测方式对比</h3>
                        <div class="small-text">Comparison of Detection Methods</div>
                    </div>
                </div>
            </div>
            <div class="common-content" id="content3">
                <div v-show="content3_content_animation" :class="{ 'fadeInUp': content3_content_animation }"
                    style="width: 100%;text-align: center;">
                    <img class="img" :src="t6" />
                    <img class="img" :src="t7" style="margin-top: 20px;" />
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="content">
                <div class="common-title" id="title4">
                    <div v-show="content4_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content4_title_animation }">
                        <div class="commit-tit">
                            <h3>应用方向</h3>
                            <div class="small-text">Application Direction</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content4">
                    <p>
                        氢气泄漏检测胶带可以用于氢气管道和适用胶带缠绕的部件。产品的应用方向包括但不限于接头、管配件、阀门、焊缝处、接缝、法兰和有振动脱落风险的位置。
                    </p>
                    <div v-show="content4_content_animation" :class="{ 'fadeInUp': content4_content_animation }"
                        style="width: 100%;display:flex;justify-content: space-between;">
                        <img class="img" :src="s1" />
                        <img class="img" :src="s2" />
                        <img class="img" :src="s3" />
                        <img class="img" :src="s4" />
                        <img class="img" :src="s5" />

                    </div>
                </div>
            </div>
        </div>

            <div class="content">
                <div class="common-title" id="title6">
                    <div v-show="content6_title_animation"
                        :class="{ 'introduct': true, 'fadeInUp': content6_title_animation }">
                        <div class="commit-tit">
                            <h3>应用场景</h3>
                            <div class="small-text">Physical Diagram of the Platform</div>
                        </div>
                    </div>
                </div>
                <div class="common-content" id="content6">
                    <div v-show="content6_content_animation" :class="{ 'fadeInUp': content6_content_animation }"
                        style="width: 100%;text-align: center;">
                        <template>
                            <el-carousel :interval="4000" type="card" :autoplay="false">
                                <el-carousel-item v-for="item in list" :key="item">
                                    <el-image style="width: 100%; height: auto" :src="item"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                    </div>
                </div>
            </div>
        <div class="anchor-content">
            <div class="anchorLine"></div>
            <ul class="anchor" @click="skipContent">
                <li :class="{ 'active': anchor == '0' ? true : false }" data-name="title0">产品介绍</li>
                <li :class="{ 'active': anchor == '1' ? true : false }" data-name="title1">变色对比</li>
                <li :class="{ 'active': anchor == '2' ? true : false }" data-name="title5">产品特性</li>
                <li :class="{ 'active': anchor == '3' ? true : false }" data-name="title2">产品规格</li>
                <li :class="{ 'active': anchor == '4' ? true : false }" data-name="title3">检测方式对比</li>
                <li :class="{ 'active': anchor == '5' ? true : false }" data-name="title4">应用方向</li>
                <li :class="{ 'active': anchor == '6' ? true : false }" data-name="title6">应用场景</li>


            </ul>
        </div>




    </div>
</template>

<script>
// 导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
    name: 'Safesystem',
    components: {

        // import引入的组件需要注入到对象中才能使用
    },
    data() {
        return {
            anchor: '',
            bannerUrl: require("@/assets/img/qtape/banner.png"),
            t1: require("@/assets/img/qtape/t1.png"),
            t2: require("@/assets/img/qtape/t2.png"),
            t3: require("@/assets/img/qtape/t3.png"),
            t4: require("@/assets/img/qtape/t4.png"),
            t5: require("@/assets/img/qtape/t5.png"),
            t6: require("@/assets/img/qtape/t6.png"),
            t7: require("@/assets/img/qtape/t7.png"),
            s1: require("@/assets/img/qtape/s1.png"),
            s2: require("@/assets/img/qtape/s2.png"),
            s3: require("@/assets/img/qtape/s3.png"),
            s4: require("@/assets/img/qtape/s4.png"),
            s5: require("@/assets/img/qtape/s5.png"),
            dui: require("@/assets/img/safe/dui.png"),
            activeName: '',
            content0_title_animation: false, content0_content_animation: false,
            content1_title_animation: false, content1_content_animation: false,
            content2_title_animation: false, content2_content_animation: false,
            content3_title_animation: false, content3_content_animation: false,
            content4_title_animation: false, content4_content_animation: false,
            content5_title_animation: false, content5_content_animation: false,
            content6_title_animation: false, content6_content_animation: false,
            list: [
                require("@/assets/img/qtape/k1.png"),
                require("@/assets/img/qtape/k2.png"),
                require("@/assets/img/qtape/k3.png"),
                require("@/assets/img/qtape/k4.png"),
                require("@/assets/img/qtape/k5.png"),
                require("@/assets/img/qtape/k6.png")
            ]
        }
    },
    created() {
        window.onscroll = false;
    },
    mounted() {
        this.$nextTick(() => {
            this.scroll();
            window.addEventListener('scroll', this.scroll)
        })
        
    },
    methods: {
        download(){
            // var a = document.createElement('a') // 创建一个<a></a>标签
            // a.href = '../../../static/氢气泄漏检测胶带使用说明书.pdf'         //重点（如测试发现下载文件不存在/找不到，检查路径）
            // a.download = 'xxx.pdf'         // 设置下载文件文件名
            // a.style.display = 'none'           // 隐藏a标签
            // document.body.appendChild(a)       // 将a标签追加到文档对象中
            // a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
            // a.remove()
            window.open('../../../static/pdf.html', 'blank') 
        },
        scroll() {
            var a = [1, 2, 3];
            const docScrollTop = document.documentElement.scrollTop - 175;

            const title0_elOffsetTop = document.getElementById("title0").offsetTop;
            const content0_elOffsetTop = document.getElementById("content0").offsetTop;
            if (title0_elOffsetTop >= docScrollTop && title0_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content0_title_animation = true;
            }
            if (content0_elOffsetTop >= docScrollTop && content0_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content0_content_animation = true;
            }

            const title1_elOffsetTop = document.getElementById("title1").offsetTop;
            const content1_elOffsetTop = document.getElementById("content1").offsetTop;
            if (title1_elOffsetTop >= docScrollTop && title1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_title_animation = true;
            }
            if (content1_elOffsetTop >= docScrollTop && content1_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content1_content_animation = true;
            }
            const title2_elOffsetTop = document.getElementById("title2").offsetTop;
            const content2_elOffsetTop = document.getElementById("content2").offsetTop;
            if (title2_elOffsetTop >= docScrollTop && title2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_title_animation = true;
            }
            if (content2_elOffsetTop >= docScrollTop && content2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_content_animation = true;
            }
            const title3_elOffsetTop = document.getElementById("title3").offsetTop;
            const content3_elOffsetTop = document.getElementById("content3").offsetTop;
            if (title3_elOffsetTop >= docScrollTop && title3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_title_animation = true;
            }
            if (content3_elOffsetTop >= docScrollTop && content3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content3_content_animation = true;
            }
            const title4_elOffsetTop = document.getElementById("title4").offsetTop;
            const content4_elOffsetTop = document.getElementById("content4").offsetTop;
            if (title4_elOffsetTop >= docScrollTop && title4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_title_animation = true;
            }
            if (content4_elOffsetTop >= docScrollTop && content4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content4_content_animation = true;
            }
            //线路示意图
            const title5_elOffsetTop = document.getElementById("title5").offsetTop;
            const content5_elOffsetTop = document.getElementById("content5").offsetTop;
            if (title5_elOffsetTop >= docScrollTop && title5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_title_animation = true;
            }
            if (content5_elOffsetTop >= docScrollTop && content5_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content5_content_animation = true;
            }
            //平台实物
            const title6_elOffsetTop = document.getElementById("title6").offsetTop;
            const content6_elOffsetTop = document.getElementById("content6").offsetTop;
            if (title6_elOffsetTop >= docScrollTop && title6_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content6_title_animation = true;
            }
            if (content6_elOffsetTop >= docScrollTop && content6_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content6_content_animation = true;
            }
        },
        mouseEnter(item) {
            console.log(item)
            this.activeName = item.target.dataset.name;
        }
        ,
        mouseOut() {
            this.activeName = ''
        },
        //锚点跳转
        skipContent(e) {
            console.log(e)
            var target = e.target.dataset.name;
            let anchorElementHeight = document.getElementById(target).offsetTop;
            window.scrollTo({ top: anchorElementHeight - 70, behavior: 'smooth' });
            switch (target) {
                case 'title0':
                    this.anchor = '0'
                    break;
                case 'title1':
                    this.anchor = '1'
                    break;
                case 'title2':
                    this.anchor = '3'
                    break;
                case 'title3':
                    this.anchor = '4'
                    break;
                case 'title4':
                    this.anchor = '5'
                    break;
                case 'title5':
                    this.anchor = '2'
                    break;
                case 'title6':
                    this.anchor = '6'
                    break;
                default:
                    break;
            }
        }
    },
}
</script>

<style scoped lang="less">
@keyframes an1 {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

@-webkit-keyframes an1

/* Safari 与 Chrome */
    {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

.fixd {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: space-Between;
    -webkit-justify-content: space-Between;
    -moz-box-pack: space-Between;
    -ms-flex-pack: space-Between;
    justify-content: space-Between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.fadeInUp {
    animation: fadeInUp 1s;
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

.fadeInRight {
    animation: fadeInRight 1s;
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
}

.fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft0 {
    animation: fadeInLeft 1.2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft1 {
    animation: fadeInLeft 1.4s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft2 {
    animation: fadeInLeft 1.6s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft3 {
    animation: fadeInLeft 1.8s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft4 {
    animation: fadeInLeft 2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
}

.banner {
    background: url('~@/assets/img/qtape/banner.png') no-repeat;
    background-size: 100% 100%;
}

.content {

    .common-title {
        text-align: center;
        margin-bottom: 53px;
    }

    .common-content {
        .fixd();
        align-items: center;

        >div:first-child {
            width: 42%;
        }

        >div:last-child {
            width: 42%;
        }

        .text {
            font-size: 14px;
            line-height: 24px;
            color: #666;
            margin-top: 25px;
            text-align: justify;

        }
    }
}

#content1 {
    divider {
        display: inline-block;
        width: 44px;
        height: 20px;
        background: url('~@/assets/img/qtape/t5.png') no-repeat;
    }
    img{
        width: 100%;
        height: 285px;
    }
}

#content0 {
    p {
        line-height: 30px;
    }

    .img-parent {
        margin-top: 40px;
        padding: 40px;
    }

    >div {
        width: 40%;
    }

    .el-divider--vertical {
        width: 1px;
        height: 15rem;
        background: url('~@/assets/img/qtape/line.png') no-repeat;
    }
}

#content2 {
    table {
        width: 100%;
        background-color: #fff;
        border-radius: 4px;

        tr {
            line-height: 45px;

            td:first-child {
                text-align: center;
            }

            td:last-child {
                text-align: left;
            }
        }

        tr:nth-child(odd) {
            background-color: #e6f3ff;
        }

        thead {
            th {
                color: #fff;
                background-color: #2a8ceb;
                text-align: left;
            }

            th:first-child {
                width: 35%;
                text-align: center;
                border-top-left-radius: 4px;
            }

            th:last-child {
                text-align: left;
                border-top-right-radius: 4px;
            }
        }

        tbody {
            border-top: 0px;
        }
    }

    p {
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
    }
}

#content4 {
    p {
        margin-bottom: 20px;
    }

    img {
        width: 19%;
    }
}

#content5 {
    table {
        width: 100%;
        text-align: left;

        tr {
            line-height: 45px;

            td {
                padding-left: 20px;
            }
        }

        tr:nth-child(odd) {
            background-image: linear-gradient(to right, #e6f3ff, #fff);
        }
        tr:nth-child(even) {
            background-image: linear-gradient(to right, #F5FAFF, #fff);
        }
    }


}

.anchor {
    li::before {
        content: '';
        display: inline-block;
        height: 28px;
        width: 28px;
        margin-right: 10px;
        vertical-align: middle;

    }

    li:nth-child(1)::before {
        background: url('~@/assets/img/qtape/y1.png') no-repeat;
    }

    li:nth-child(1).active::before,
    li:nth-child(1):hover::before {
        background: url('~@/assets/img/qtape/y11.png') no-repeat;
    }

    li:nth-child(2)::before {
        background: url('~@/assets/img/qtape/y2.png') no-repeat;
    }

    li:nth-child(2).active::before,
    li:nth-child(2):hover::before {
        background: url('~@/assets/img/qtape/y22.png') no-repeat;
    }

    li:nth-child(3)::before {
        background: url('~@/assets/img/qtape/y3.png') no-repeat;
    }

    li:nth-child(3).active::before,
    li:nth-child(3):hover::before {
        background: url('~@/assets/img/qtape/y33.png') no-repeat;
    }

    li:nth-child(4)::before {
        background: url('~@/assets/img/qtape/y4.png') no-repeat;
    }

    li:nth-child(4).active::before,
    li:nth-child(4):hover::before {
        background: url('~@/assets/img/qtape/y44.png') no-repeat;
    }

    li:nth-child(5)::before {
        background: url('~@/assets/img/qtape/y5.png') no-repeat;
    }

    li:nth-child(5).active::before,
    li:nth-child(5):hover::before {
        background: url('~@/assets/img/qtape/y55.png') no-repeat;
    }

    li:nth-child(6)::before {
        background: url('~@/assets/img/qtape/y6.png') no-repeat;
    }

    li:nth-child(6).active::before,
    li:nth-child(6):hover::before {
        background: url('~@/assets/img/qtape/y66.png') no-repeat;
    }

    li:nth-child(7)::before {
        background: url('~@/assets/img/qtape/y7.png') no-repeat;
    }

    li:nth-child(7).active::before,
    li:nth-child(7):hover::before {
        background: url('~@/assets/img/qtape/y77.png') no-repeat;
    }
}

.down{
    position: absolute;
    right:calc(50vw - 500px);
    background-color: #2895ea;
    color: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/page/qtape.vue